import { haveAnyValue } from 'src/utils/utilitiesV2'

/**
 * Get cookie by name
 * @param name
 */
function getCookieByName(name) {
  const all = document.cookie ? document.cookie.split('; ') : []
  const prefix = `${name}=`

  for (const c of all) {
    if (c.startsWith(prefix)) {
      const value = c.substring(prefix.length)
      return decodeURIComponent(value)
    }
  }
  return null
}

export { getCookieByName }
